
import firebase from 'firebase';
import React, {useState} from 'react';
import styled from 'styled-components';

import HeroDiv from '../components/HeroDiv';

const FlexContainer = styled.div`
    display: flex;

    overflow: hidden;

    @media screen and (max-width: 1068px) {
        flex-direction: column;
    }
`;

const RegisterDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 375px;
    min-width: 375px;

    @media screen and (max-width: 1068px) {
        max-width: 100vw;
        min-width: 100vw;
        padding-top: 40px;
        padding-bottom: 10vh;
    }

    @media screen and (max-width: 425px) {
        max-width: 100vw;
        min-width: 100vw;
    }
`;

const RegisterHeading = styled.text`
    

    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 54px;


    /* primary-black-text */

    color: #464646;
`;

const RegisterForm = styled.form`
    display: flex;
    flex-direction: column;
`;

const Input = styled.input`
    border-radius: 9px;
    height: 43px;
    margin-bottom: 33px;
    width: 271px;
    padding-left: 56px;

    background: url(${props => props.icon}) 12px no-repeat;

`;

const RegisterButton = styled.button`
    color: #fff;
    background: #1D599B;
    border: none;
    border-radius: 9px;
    height: 44px;
    width: 271px;

    :hover {
        cursor: pointer;
    }
`;

const ErrorText = styled.text`
    color: red;
    margin-top: 33px;
    max-width: 271px;
`;

const SecondaryText = styled.text`
    margin-top: 58px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;

    // text-align: center;
    // margin: 0 auto;

    /* primary-black-text */

    color: #464646;

`;




const Register = () => {

    let auth = firebase.auth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [message, setMessage] = useState('');

    const updateEmail = (e) => {
        setEmail(e.target.value);
    }

    const updatePassword = (e) => {
        setPassword(e.target.value);
    }

    const updatePassword2 = (e) => {
        setPassword2(e.target.value);
    }

    const createUser = (e) => {
        e.preventDefault();

        if (email.trim() === '' || password.trim() === '' || password2.trim() === '') {
            setMessage('Please fill out all fields.');
        }

        else if (password !== password2) {
            setMessage('Passwords do not match. Please check your password');
        }

        else {

            auth.createUserWithEmailAndPassword(email, password).then( cred => {
                console.log(cred);

                setMessage('Signup Successful!');
            })
            
            // display error messages
            .catch((error) => {
                let errorCode = error.code;
                let errorMessage = error.message;
                console.log(errorCode, errorMessage);

                // invalid email/password error
                if (errorCode === 'auth/wrong-passord' || errorCode === 'auth/user-not-found') {
                    setMessage('Invalid Email/Password');
                }

                // invalid email address format error
                else if (errorCode === 'auth/invalid-email') {
                    setMessage('Invalid email address. Please use a correct email address.');
                }

                else {
                    setMessage(errorMessage);
                }

            });
        }
    }



    return (


        <FlexContainer>

            <HeroDiv />



            <RegisterDiv>

                <RegisterForm onSubmit={createUser}>
                    <RegisterHeading>Sign Up</RegisterHeading> <br />
                    <Input icon='carbon_email.svg' type="email" placeholder='Email' onChange={updateEmail} />
                    <Input icon='carbon_password.svg' type="password" name="password" value={password} placeholder='Enter your password' id="password" onChange={updatePassword} />
                    <Input icon='carbon_password.svg' type="password" name="password2" value={password2} placeholder='Enter your password again' id="password" onChange={updatePassword2} />
                    <RegisterButton type="submit">Create Account</RegisterButton>
                </RegisterForm>
                <ErrorText>{message}</ErrorText>

                <SecondaryText>Already a member? <a href='/login'>Login</a> </SecondaryText>
            </RegisterDiv>

        </FlexContainer>

    );
};

export default Register;